import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { Component, OnInit, OnChanges, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IKeyValueInterface } from './../../shared/config';
import { BookingService } from '../../booking/models/booking.service';
import { BookingOverviewList } from '../../booking/models/booking-overviewlist.model';
import {
  WeGoConfig,
  IAPIResponse,
  DataListModel,
  ApplicationRouteURL,
  BookingStatus,
  BookingType
} from '../../shared/config';
import { SearchBookingModel } from '../../booking/models/search-booking.model';

const moment = require('moment');

@Component({
  selector: 'wego-booking-overview-driver',
  template: require('../views/booking-overview-driver.component.html'),
  providers: [BookingService]
})
export class BookingOverviewDriverComponent implements OnInit {
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  apiErrorMsg: string;
  DataListModel: DataListModel;
  errorModel: IKeyValueInterface[];
  readMore: IKeyValueInterface[];
  bookingList: BookingOverviewList[];
  isLoading: boolean;
  isParentCheck: boolean;
  message: string;
  popupMessage: string;
  remarks: string;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  model: BookingOverviewList = new BookingOverviewList();
  isParentCheckEnable: boolean;
  remarkslength: number = 15;
  urlBooking: string;
  urlDefaultPage: string;
  urlBookingInformation: string;
  urlDriverBookingInformation: string;
  bookingHashId: string;
  recurringId: string;
  isRecurringSeriesEditablestring: boolean;
  private popupMsg: string;
  private module: string;
  bookingSearchModel: SearchBookingModel = new SearchBookingModel();

  @ViewChild('cancelModal') public cancelModal: any;
  @ViewChild('revokeAborkModal') public revokeAborkModal: any;
  @ViewChild('remarksModal') public remarksModal: any;
  @ViewChild('EditBookingModal') public editBookingModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('creditCardPaymentModal') public creditCardPaymentModal: any;

  popupTitle: string;
  isSuccess: boolean;
  popupDescription: string;
  initialPaymentPopupTitle: string;
  public isAllowInitialPaymentValue: boolean = false;
  errorMessage: string;

  get isAnyChecked(): boolean {
    if (this.bookingList) {
      let isCheck = this.bookingList.some(x => x.isChecked == true);
      if (isCheck) {
        if (
          this.bookingList
            .filter(
              y =>
                (y.bookingStatus == BookingStatus.CONFIRMED ||
                  y.bookingStatus == BookingStatus.PENDING) &&
                y.bookingType == BookingType.NORMAL &&
                y.startDateTime >
                  moment()
                    .utc()
                    .format('DD-MM-YYYY HH:mm')
            )
            .every(x => x.isChecked == true)
        )
          this.isParentCheck = true;
        else this.isParentCheck = false;
      } else {
        this.isParentCheck = false;
      }

      return isCheck;
    } else {
      this.isParentCheck = false;
      return false;
    }
  }
  constructor(
    private authService: AuthService,
    private bookingService: BookingService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.module = this.translate.instant('LblBooking');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = [
      'licenceTag',
      'translatedBookingStatus',
      'bookingReferenceID'
    ];
    this.model = new BookingOverviewList();
    this.model.startDateTime = moment().format('DD-MM-YYYY 00:00');
    this.model.endDateTime = moment()
      .add(+1, 'M')
      .format('DD-MM-YYYY 00:00');
    this.model = this.authService.AssignFromStorage(
      this.constructor.name + '_model',
      this.model
    );
    console.log(this.model);
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.urlBooking = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING);
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlBooking = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING);
    this.urlBookingInformation = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_INFORMATION
    );
    this.urlDriverBookingInformation = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_INFORMATION_DRIVER
    );
    this.GetBookingOverview();
  }
  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    //flatPickrConfig.enableSeconds = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }
  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetBookingOverview();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    if (event.isReset) {
      this.model.startDateTime = moment().format('DD-MM-YYYY 00:00');
      this.model.endDateTime = moment()
        .add(+1, 'M')
        .format('DD-MM-YYYY 00:00');
    }
    this.GetBookingOverview();
  }
  public OnDateSearch() {
    this.GetBookingOverview();
  }
  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetBookingOverview();
  }
  public OnExport(event: any) {
    this.isLoading = true;
    this.bookingService
      .ExportBokingList(this.model, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = 'Booking' + new Date().toISOString() + '.csv';
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }
  private GetBookingOverview() {
    this.isLoading = true;
    this.bookingService
      .GetBookingOverviewList(this.model, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res.data) {
            this.bookingList = res.data;
            this.isParentCheckEnable =
              this.bookingList.filter(x => x.isBookingCancel).length > 0
                ? true
                : false;
            this.DataListModel.totalItems = res.totalRecords;
            this.DataListModel.infoMessage = res.error;
            this.isLoading = false;
            this.errorModel = null;
          } else {
            this.DataListModel.totalItems = res.totalRecords;
            this.DataListModel.infoMessage = this.translate.instant(
              'LblNoRecords'
            );
            this.errorModel = res.error;
            this.bookingList = null;
            this.isLoading = false;
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetBookingOverview();
  }

  public OnParentCheck(isChecked: boolean) {
    this.bookingList
      .filter(
        y =>
          (y.bookingStatus == BookingStatus.CONFIRMED ||
            y.bookingStatus == BookingStatus.PENDING) &&
          y.bookingType == BookingType.NORMAL &&
          y.startDateTime >
            moment()
              .utc()
              .format('DD-MM-YYYY HH:mm')
      )
      .forEach(x => (x.isChecked = isChecked));
  }

  onSubmit(forms: any) {
    //this.model.listOfBookingHashId = this.bookingList.filter(x => x.isChecked).map(x => x.bookingHashId);
    this.CancelBookings(JSON.stringify(this.model));
  }

  public CancelBookings(formData: any) {
    this.isLoading = true;
    this.bookingService.CancelBookings(formData).subscribe(
      (res: any) => {
        if (res.data) {
          this.DataListModel.currentPage = 1;
          this.GetBookingOverview();
          this.cancelModal.hide();
          this.isLoading = false;
          this.popupMsg = this.translate.instant('LblBookingCancelSuccess', [
            this.module
          ]);
          this.ShowSuccessPopup();
        } else {
          this.errorModel = res.error;
          this.isLoading = false;
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ShowCancelModal(bookingReferenceId: string): void {
    this.model.remarks = null;
    this.errorModel = null;
    this.model.listOfBookingHashId = [];
    this.model.listOfBookingHashId.push(bookingReferenceId);
    this.cancelModal.show();
  }

  public HideCancelModal(): void {
    this.cancelModal.hide();
  }

  public SuccessCancelModalClick(): void {
    this.cancelModal.hide();
  }

  onSubmitAbortRevoke(forms: any) {
    this.RevokeAbortBooking(JSON.stringify(this.model));
  }

  public RevokeAbortBooking(formData: any) {
    this.isLoading = true;
    this.bookingService.RevokeOrAbortBookings(formData).subscribe(
      (res: any) => {
        if (res.data) {
          this.DataListModel.currentPage = 1;
          this.GetBookingOverview();
          this.revokeAborkModal.hide();
          this.isLoading = false;
          this.popupMsg =
            this.popupMessage == BookingStatus.ABORTED
              ? this.translate.instant('LblBookingAbortSuccess')
              : this.translate.instant('LblBookingRevokeSuccess');

          this.ShowSuccessPopup();
        } else {
          this.errorModel = res.error;
          this.isLoading = false;
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ShowAbort(bookingHashId: string, bookingStatus: string) {
    this.model.remarks = null;
    this.model.bookingHashId = bookingHashId;
    this.model.bookingStatus = BookingStatus.ABORTED;
    this.popupMessage = BookingStatus.ABORTED;
    this.errorModel = null;
    this.revokeAborkModal.show();
  }

  public ShowRevoke(bookingHashId: string, bookingStatus: string) {
    this.model.remarks = null;
    this.model.bookingHashId = bookingHashId;
    this.model.bookingStatus = BookingStatus.REVOKED;
    this.popupMessage = BookingStatus.REVOKED;
    this.errorModel = null;
    this.revokeAborkModal.show();
  }

  public HideRevokeAbortModal(): void {
    this.revokeAborkModal.hide();
  }

  public SuccessRevokeAbortModal(): void {
    this.revokeAborkModal.hide();
  }

  //Addedd for remarksModal

  public ShowRemakrsModal(remarks: string) {
    this.remarks = remarks;
    this.remarksModal.show();
  }
  public HideRemarksModal() {
    this.remarks = null;
    this.remarksModal.hide();
  }
  //Addedd for edit recurringbooking

  public ShowBookingModal(
    isRecurringSeriesEditable: boolean,
    bookingHashId?: string,
    recurringID?: string
  ): void {
    if (isRecurringSeriesEditable) {
      if (bookingHashId) this.bookingHashId = bookingHashId;
      if (recurringID) this.recurringId = recurringID;
      this.editBookingModal.show();
    } else {
      this.router.navigate([
        this.urlBooking,
        { ref: this.recurringId, isRecurring: true }
      ]);
    }
  }
  public SuccessSingleBooking(): void {
    this.editBookingModal.hide();
    this.router.navigate([
      this.urlBooking,
      { ref: this.bookingHashId, isRecurring: false }
    ]);
  }
  public SuccessRecurringBooking(): void {
    this.editBookingModal.hide();
    this.router.navigate([
      this.urlBooking,
      { ref: this.recurringId, isRecurring: true }
    ]);
  }
  public HideBookingModal(): void {
    this.editBookingModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public OnPayment(bookingHashId: string) {
    this.isLoading = true;
    this.bookingHashId = bookingHashId;
    this.bookingService
      .ConfirmRecurringPaymentBooking(bookingHashId, this.recurringId)
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res.data) {
            if (res.data.askForInitialPayment) {
              this.popupDescription = this.translate.instant(
                'LblPaymentDescription',
                [res.data.initialPaymentAmount]
              );
              if (res.data.isPaymentSuccess || res.data.isFirstTimePayment) {
                this.initialPaymentPopupTitle = this.translate.instant(
                  'LblFirstBooking'
                );
              } else {
                this.initialPaymentPopupTitle = this.translate.instant(
                  'LblPaymentFailed'
                );
              }
              this.isAllowInitialPaymentValue = false;
              this.creditCardPaymentModal.show();
            } else if (
              !res.data.askForInitialPayment &&
              res.data.isPaymentSuccess
            ) {
              this.isLoading = true;
              //call api
              this.bookingService
                .UpdateBookingAfterSuccessfulPayment(this.bookingHashId)
                .subscribe((res: any) => {
                  this.isLoading = false;
                  this.DataListModel.currentPage = 1;
                  this.GetBookingOverview();
                  this.popupMsg = res.data;
                  this.ShowSuccessPopup();
                });
            } else {
            }
          } else {
            this.popupTitle = this.translate.instant('LblWarning');
            this.popupMsg = res.error;
            this.isSuccess = false;
            // this.ShowSuccessPopup();
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  public GetInitialPaymentValue(isAllowInitialPayment: any) {
    this.isAllowInitialPaymentValue = isAllowInitialPayment;
  }

  public ConfirmInitialPayment(): void {
    this.isLoading = true;
    if (this.isAllowInitialPaymentValue == false) {
      this.isLoading = false;
      const errorMessage = this.translate.instant('LblCheckAllowPayment');
      this.errorMessage = errorMessage + ':' + Date.now().toString();
    } else {
      this.bookingSearchModel.bookingMasterHashId = this.bookingHashId;
      this.bookingSearchModel.isFromMobileSide = false;
      this.bookingService
        .StartInitialPayment(this.bookingSearchModel)
        .subscribe(res => {
          if (res.data.redirectURL) {
            this.isLoading = false;
            window.location.href = res.data.redirectURL;
          } else {
            this.isLoading = false;
            this.creditCardPaymentModal.hide();
            this.popupMsg = res.error;
            this.ShowSuccessPopup();
          }
        });
    }
  }

  public GetImageURL(imagePath: string) {
    return WeGoConfig.API_SERVER_URL + imagePath;
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
    this.authService.SaveToStorage(
      this.constructor.name + '_model',
      this.model
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking-driver/components/booking-overview-driver.component.ts